import moment from 'moment';
import axios from './axios';

export const getPushNotificationLogs = async (token, limit = 100) => {
  try {
    const response = await axios.get('/push-notification/logs', {
      headers: { Authorization: `Bearer ${token}` },
      params: { page: 1, limit },
    });
    return response.data.data.map((log) => {
      const sentAt = log.createdAt ?? log.created_at;
      return {
        ...log,
        createdAt: moment(sentAt).isValid()
          ? moment(sentAt).format('DD/MM/YYYY HH:mm:ss')
          : sentAt,
      };
    });
  } catch (error) {
    return error.response;
  }
};

export const getRecipientCount = async (token, audience) => {
  try {
    const response = await axios.get('/push-notification/recipient-count', {
      headers: { Authorization: `Bearer ${token}` },
      params: { audience },
    });
    return response.data.data.recipientCount;
  } catch (error) {
    return null;
  }
};

export const sendPushNotification = async (token, { title, body, audience }) => {
  try {
    const response = await axios.post(
      '/push-notification/send',
      { title, body, audience },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response;
  } catch (err) {
    return err.response;
  }
};
